<template>

  <div class="user">

    <!--添加商家-->

    
    <div class="common-seach-wrap">
      <el-form size="small" :inline="true" :model="formInline" class="demo-form-inline">
        <el-form-item label="">
          <el-input v-model="formInline.title" placeholder="请输入圈子主题"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSubmit">查询</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="product-content">
      <el-form ref="form" :model="form" label-width="100px">
        <div class="table-wrap">
          <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">
            <el-table-column prop="activity_id" label="圈子ID" ></el-table-column>
            <el-table-column prop="imgUrl" label="圈子封面" width="150">
              <template slot-scope="scope">
                <img v-img-url="scope.row.imgUrl" style="width: 60px;" />

              </template>

            </el-table-column>
            <el-table-column prop="title" label="圈子主题" width="150"></el-table-column>

            <el-table-column prop="categorya.name" label="分类" >
              <template slot-scope="scope">
                <span v-if="scope.row.categorya" >{{ scope.row.categorya.name}}</span>
                <span v-else >无分类</span>
              </template>
              
            </el-table-column>

            <el-table-column prop="price" label="价格" ></el-table-column>
         
          
            <el-table-column prop="create_time" label="创建时间" ></el-table-column>
            <el-table-column fixed="right" label="操作" width="90">
              <template slot-scope="scope">
                <el-button @click="detailClick(scope.row)" type="text" size="small">参与详情</el-button>
                <el-button @click="qzClick(scope.row)" type="text" size="small">圈子内容</el-button>
                <el-button @click="editClick(scope.row)" type="text" size="small">编辑</el-button><br />
                <el-button @click="deleteClick(scope.row)" type="text" size="small">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-form>
      <!--分页-->
      <div class="pagination">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" background :current-page="curPage"
           :page-size="pageSize" layout="total, prev, pager, next, jumper"
          :total="totalDataNumber">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import activityApi from '@/api/activity.js';
export default {
  components: {},
  inject: ['reload'],
  data() {
    return {
      /*是否加载完成*/
      loading: true,
      /*列表数据*/
      tableData: [],
      /*一页多少条*/
      pageSize: 20,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1,
      /*搜索表单对象*/
      form: {},
      /*是否打开添加弹窗*/
      open_add: false,
      /*是否打开编辑弹窗*/
      open_edit: false,
      /*当前编辑的对象*/
      userModel: {},
      formInline: {},
      status: ['未开始', '进行中', '已结束'],
    };
  },
  created() {

    /*获取列表*/
    this.getTableList();
  },
  methods: {

    /*选择第几页*/
    handleCurrentChange(val) {
      this.curPage = val;
      this.getTableList();
    },

    /*每页多少条*/
    handleSizeChange(val) {
      this.curPage = 1;
      this.pageSize = val;
      this.getTableList();
    },

    /*获取列表*/
    getTableList() {
      let self = this;
      let Params = this.formInline;
      Params.page = self.curPage;
      Params.list_rows = self.pageSize;
      self.loading = true;
      activityApi.activityList(Params, true)
        .then(data => {
          self.loading = false;
          self.tableData = data.data.list.data;
          console.log(self.tableData)
          self.totalDataNumber = data.data.list.total;
        })
        .catch(error => {});
    },

    /*搜索查询*/
    onSubmit() {
      this.curPage = 1;
      this.getTableList();
    },

    /* 房源详情 */
    detailClick(row){
      let activity_id = row.activity_id;
       this.$router.push({
        path: '/plus/activity/activity/detail',
        query: {
          activity_id: activity_id
        }
      });
    },
    qzClick(row){
      let activity_id = row.activity_id;
       this.$router.push({
        path: '/plus/dynamic/index',
        query: {
          activity_id: activity_id
        }
      });
    },

    /* 浏览记录 */
    browseClick(row){
      let activity_id = row.activity_id;
       this.$router.push({
        path: '/plus/activity/activity/browse',
        query: {
          activity_id: activity_id
        }
      });
    },

    /*添加房源*/
    addClick() {
      this.$router.push('/plus/activity/activity/add');
    },

    /*编辑房源*/
    editClick(row) {
      let activity_id = row.activity_id;
      this.$router.push({
        path: '/plus/activity/activity/edit',
        query: {
          activity_id: activity_id
        }
      });
    },

    /*删除*/
    deleteClick(row) {
      let self = this;
      self
        .$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        .then(() => {
          activityApi.delActivity(
            {
              activity_id: row.activity_id
            },
            true
          )
            .then(data => {
              if (data.code == 1) {
                self.$message({
                  message: '删除成功',
                  type: 'success'
                });
                this.onSubmit();
              } else {
                self.$message.error('错了哦，这是一条错误消息');
              }
            })
            .catch(error => {});
        })
        .catch(() => {});
    },
    
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/plus/activity/activity/index.vue